export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const SET_GROUPS_FILTERS = 'SET_GROUPS_FILTERS';
export const RESET_GROUPS_FILTERS = 'RESET_GROUPS_FILTERS';
export const SET_FETCHING_GROUPS = 'SET_FETCHING_GROUPS';